import React, { useEffect, useState } from 'react';
import { Col, Row, Button, Table, Form } from 'react-bootstrap';
import ReactApexChart from "react-apexcharts";
import Icon from '@mdi/react';
import { mdiDownload, mdiPrinter } from '@mdi/js';
import { getFromAPI,API_BASE_URL } from '../../Utils/utils';
import {toast} from 'react-toastify';

export default function SalaryPayslip() {
    const [selectedPayslip, setSelectedPayslip] = useState('');
    const isStaffId = Number(localStorage.getItem("loggedInStaffId"));
    const [months, setMonths] = useState([]);
    const [payslipData,setPaySlipData] = useState([]);
    const handlePayslipClick = (payslip) => {
        setSelectedPayslip(payslip);
    };

    const downloadPayslip = async (staffId, month) => {
        // Validate inputs before making the request
        if (!staffId || !month || month === "undefined") {
            toast.error("PaySlip Not Found", "error");
            return;
        }
    
        try {
            const url = `${API_BASE_URL}generate_payroll_slip1/?staff_id=${staffId}&month=${month}`; 
            window.open(url, '_blank'); // Opens in a new tab
        } catch (error) {
            console.error('Error opening payslip:', error);
        }
    };

    useEffect(() => {
        const fetchPaySlipData = async () => {
            if (!selectedPayslip || !selectedPayslip.month) return;
            try {
                const response = await getFromAPI(`FtsPayrollDetails/?staffId=${isStaffId}&month=${selectedPayslip.month}`);
                if (response && response.length > 0) {
                    setPaySlipData(response[0]);
                } else {
                    setPaySlipData([]);
                }
            } catch (error) {
                console.error("Error fetching payslip data:", error);
            }
        };
        fetchPaySlipData();
    }, [selectedPayslip]); // ✅ Fetch payslip data when selectedPayslip changes

    const monthNames = [
        "January", "February", "March", "April", "May", "June",
        "July", "August", "September", "October", "November", "December"
    ];

    useEffect(() => {
        const fetchStaffData = async () => {
            try {
                const response = await getFromAPI(`FtsPayrollDetails/?staffId=${isStaffId}&payment_status=3`);
                if (response && response.length > 0) {
                    const uniqueMonths = [...new Set(response.map(item => item.month))].sort((a, b) => a - b);
                    setMonths(uniqueMonths);
    
                    // Set first payslip as default if none is selected
                    if (uniqueMonths.length > 0 && !selectedPayslip) {
                        setSelectedPayslip({ month: uniqueMonths[0] });
                    }
                } else {
                    setMonths([]);
                }
            } catch (error) {
                console.error("Error fetching months:", error);
            }
        };
        fetchStaffData();
    }, []);
    

    // Update the chart when payrollData changes
    useEffect(() => {
        if (payslipData) {
            setState((prevState) => ({
                ...prevState,
                series: [payslipData.net_salary],
            }));
        }
    }, [payslipData]);
    
    const [state, setState] = useState({
        series: [0],
        options: {
            chart: {
                type: "donut",
                width: 350,
            },
            labels: ["Take Home"],
            legend: {
                show: false,
            },
            dataLabels: {
                enabled: false, // Disables default data labels
            },
            plotOptions: {
                pie: {
                    donut: {
                        labels: {
                            show: true,
                            total: {
                                show: true,
                                label: "Salary",
                            },
                        },
                    },
                },
            },
            colors: ["#5570F7", "#dc3545"],
        },
    });
    
    // Check if there’s a valid month selected and payslip data exists
    const hasValidPayslip = () => {
        return selectedPayslip && selectedPayslip.month && payslipData && Object.keys(payslipData).length > 0;
    };

    return (
        <>
            <Row>
            <Col lg={3} xxl={2}>
                {months.length > 0 ? (
                    <div className='p-4 border rounded-2'>
                    <div className="d-flex justify-content-between align-items-center gap-2 mb-4">
                        {/* Uncomment if you want to include the financial year dropdown */}
                        {/* <Form.Label className="mb-0 h5">Financial Year </Form.Label>
                        <Form.Select size='sm' className='w-auto'>
                        <option value="2024-25">2024 - 25</option>
                        <option value="2023-24">2023 - 24</option>
                        <option value="2022-23">2022 - 23</option>
                        <option value="2021-22">2021 - 22</option>
                        </Form.Select> */}
                    </div>
                    <div className="payslip-info-scroll">
                        {months.map((month) => {
                        const currentYear = new Date().getFullYear();
                        const displayYear = month <= 3 ? currentYear : currentYear - 1;
                        const isSelected = selectedPayslip && selectedPayslip.month === month;

                        return (
                            <div
                            key={month}
                            className={`border-0 mb-3 p-2 cursor-pointer ${isSelected ? 'bg-primary text-white' : ''}`}
                            onClick={() => handlePayslipClick({ month })}
                            >
                            <h6 className="mb-1">{monthNames[month - 1]} {displayYear}</h6>
                            </div>
                        );
                        })}
                    </div>
                    </div>
                ) : null}
                </Col>
                <Col lg={9} xxl={10}>
                    <div className='ms-lg-5 mt-lg-0 mt-5'>
                    <h5 className='mb-4'>
                            {hasValidPayslip()
                                ? `Payslip for ${monthNames[payslipData.month - 1]}`
                                : ''}
                    </h5>                       
                    <Row className='align-items-center'>
                            <Col md={4} xl={3}>
                                <div>
                                    <ReactApexChart options={state.options} series={state.series} type="donut" height={200} />
                                </div>
                            </Col>
                            <Col md={8} xl={9}>
                                <div className='mt-4 mt-lg-0'>
                                    <div className="d-sm-flex flex-wrap text-center text-sm-start justify-content-between">
                                        <div>
                                        <h4>Take Home: ₹{Number(payslipData.net_salary || 0)}</h4>
                                        </div>
                                        <div>
                                            <Button variant="success" onClick = {()=>downloadPayslip(isStaffId,selectedPayslip.month)} disabled={!hasValidPayslip()}>Download Slip <Icon path={mdiDownload} className='icon-size-16 ms-1' /></Button>{' '}
                                            {/* <Button variant="primary">Print <Icon path={mdiPrinter} className='icon-size-16 ms-1' /></Button> */}
                                        </div>
                                    </div>
                                    <Row className='mt-4'>
                                        <Col sm={6} xl={4} className='mb-4 mb-sm-0'>
                                            <div className='p-4 text-center border bg-soft-danger border-soft-danger rounded-2 h-100'>
                                                <h5 className='fw-normal'>Deductions</h5>
                                                <p className='text-muted mb-0'>₹{Math.round(Number(payslipData.pf || 0)+Number(payslipData.profession_tax || 0)+Number(payslipData.deducted_hour_amount || 0)+Number(payslipData.lop_deducted_amount || 0)+Number(payslipData.joining_month_deduction || 0)+Number(payslipData.employee_esi || 0)+Number(payslipData.employee_pf || 0))}</p>
                                            </div>
                                        </Col>
                                        <Col sm={6} xl={4} className='mb-4 mb-sm-0'>
                                            <div className='p-4 text-center border bg-soft-info border-soft-info rounded-2 h-100'>
                                                <h5 className='fw-normal'>Total Earnings</h5>
                                                <p className='text-muted mb-0'>₹{Math.round(Number(payslipData.basic_salary || 0) + Number(payslipData.hra || 0) + Number(payslipData.reimbursements || 0) + Number(payslipData.conveynace_allowance || 0) + Number(payslipData.medical_allowance || 0) + Number(payslipData.telephone_allowance || 0))}</p>
                                            </div>
                                        </Col>
                                    </Row>
                                </div>
                            </Col>
                        </Row>
                        <hr />
                        <h5 className='mb-3 mt-4 fw-normal'>PaySlip Details</h5>
                        <div className='bg-light bg-opacity-50 border p-4 rounded-2'>
                            <Row>
                                <Col sm={4}>
                                    <h5 className='fw-normal mb-3'>{monthNames[payslipData.month-1] || 'NA'}</h5>
                                    <p className='text-muted mb-0'>Paid Days : {payslipData.total_working_days || 0}   LOP Days : {(Number(payslipData.total_working_days)-Number(payslipData.adjusted_working_days)) || 0 }</p>
                                </Col>
                                <Col sm={4}>
                                    <h5 className='fw-normal mt-sm-0 mt-4 mb-3'>Bank Account No</h5>
                                    <p className='text-muted mb-0'>{payslipData.accountNumber || 'NA'}</p>
                                </Col>
                                <Col sm={4}>
                                    <h5 className='fw-normal mt-sm-0 mt-4 mb-3'>UAN</h5>
                                    <p className='text-muted mb-0'>-</p>
                                </Col>
                            </Row>
                        </div>

                        <Table responsive bordered className='table-nowrap mt-5'>
                            <thead className='table-light'>
                                <tr>
                                    <th>Earnings</th>
                                    <th></th>
                                    <th>Deductions</th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr>
                                    <td>Basic Salary</td>
                                    <td></td>
                                    <td>Professional Tax</td>
                                    <td>₹{payslipData.profession_tax || 0}</td>
                                </tr>
                                <tr>
                                    <td>Basic</td>
                                    <td>₹{payslipData.basic_salary || 0}</td>
                                    <td>LOP Deductions</td>
                                    <td>₹{Math.round(Number(payslipData.deducted_hour_amount || 0)+Number(payslipData.lop_deducted_amount || 0)+Number(payslipData.joining_month_deduction || 0))}</td>
                                </tr>
                                <tr>
                                    <td>Basic Arrear</td>
                                    <td>-</td>
                                    <td>Employee ESI</td>
                                    <td>₹{Number(payslipData.employee_esi || 0)}</td>
                                </tr>
                                <tr>
                                    <td>Basic % Arrear</td>
                                    <td>-</td>
                                    <td>Employee VPF</td>
                                    <td>₹{Number(payslipData.employee_pf || 0)}</td>
                                </tr>
                                <tr>
                                    <td>House Rent Allowance</td>
                                    <td>₹{payslipData.hra || 0}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>House Rent Allowance Arrear</td>
                                    <td>-</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>House Rent Allowance % Arrear</td>
                                    <td>-</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Conveyance Allowance</td>
                                    <td>₹{payslipData.conveynace_allowance || 0}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Conveyance Allowance Arrear</td>
                                    <td>-</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Fixed Allowance</td>
                                    <td>-</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Fixed Allowance Arrear</td>
                                    <td>-</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Telephone Allowance</td>
                                    <td>₹{payslipData.telephone_allowance||0}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                <tr>
                                    <td>Rembuirshment</td>
                                    <td>₹{payslipData.reimbursements||0}</td>
                                    <td></td>
                                    <td></td>
                                </tr>
                                
                                <tr>
                                    <th>Total Earnings</th>
                                    <th>₹{Math.round(Number(payslipData.basic_salary || 0) + Number(payslipData.hra || 0) + Number(payslipData.conveynace_allowance || 0)  + Number(payslipData.telephone_allowance || 0)+ Number(payslipData.reimbursements || 0))}</th>
                                    <th>Total Deductions</th>
                                    <th>₹{Math.round(Number(payslipData.pf || 0)+Number(payslipData.profession_tax || 0)+Number(payslipData.deducted_hour_amount || 0)+Number(payslipData.lop_deducted_amount || 0)+Number(payslipData.joining_month_deduction || 0)+Number(payslipData.employee_esi || 0)+Number(payslipData.employee_pf || 0))}</th>
                                </tr>
                            </tbody>
                        </Table>

                        <div className='d-flex justify-content-between flex-wrap'>
                            <p className='text-muted'>Your Take Home Salary Amount (Net Pay)</p>
                            <p className='text-muted'>Net Pay = Total Earnings - Total Deductions</p>
                        </div>
                        <h4 className='mt-4'>₹{payslipData.net_salary || 0}</h4>
                        <p className='text-muted'>Indian Rupee Twenty Five Thousand Rupees</p>
                    </div>
                </Col>
            </Row>
        </>
    )
}
